import { useParams } from 'react-router-dom';
import BoiteExpedition from '../components/BoiteExpedition';
import Cartes from '../components/Cartes';
import OffsetImprime from '../components/OffsetImprime';
import SacsImprime from '../components/SacsImprime';
import CoffretOreille from '../components/CoffretOreille';
import CaisseAmericaine from '../components/CaisseAmericaine';
import Etuis from '../components/Etuis';
import BoiteAvecOreilles from '../components/BoiteAvecOreilles';
import './ProductsView.css';

const ProductsView = () => {
  const { productId } = useParams(); // This will now correctly get the productId from the URL

  // Map product IDs to components
  const productComponents = {
    'boite-expedition': <BoiteExpedition />,
    'offset-imprime': <OffsetImprime />,
    'sacs-imprime': <SacsImprime />,
    'coffret-oreille': <CoffretOreille />,
    'etuis': <Etuis />,
    'caisse-americaine': <CaisseAmericaine />,
    'boite-avec-oreilles': <BoiteAvecOreilles />,
    'cartes': <Cartes />,
  };

  // Render the selected product component or nothing
  const selectedProduct = productComponents[productId];

  return (
    <div className="ProductsView">
      {selectedProduct || null}
    </div>
  );
};

export default ProductsView;